/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import twitter from '../assets/twitter-.png';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import logoPic from '../assets/logo.jpg';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';
import Footer from '../components/footer';
import banner from '../assets/banner.png';
import line from '../assets/line.png';
import line2 from '../assets/line2-2.png';
import line2_3 from '../assets/line2-3.png';
import line3 from '../assets/line3.jpg';
import back from '../assets/back.png';
import coin from '../assets/coin.png';
import correct from '../assets/check-mark.png';
import warning from '../assets/warning.png';
import $ from 'jquery';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork, useDisconnect } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import Story from '../components/story';
import Countdown from 'react-countdown';
import Steps from '../components/steps';
import Intro from '../components/intro';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { pulsechainV4 } from 'viem/chains';

import contractRaffle from '../contractData/contractRaffle.json';
import contractToken from '../contractData/contractToken.json';

var Scroll = require('react-scroll');

$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2000);
});

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	/*	if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {*/
	// Render a countdowns

	if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

		window.location.reload(true);
		console.log("Mint Begins");
	}


	return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
	/*	}*/
};

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const tweet = () => {
	window.open("#");
}

const discord = () => {
	window.open("#");
}

const os = () => {
	window.open("#");
}

const address = contractRaffle.address;
const ABI = contractRaffle.abi;

const addressToken = contractToken.address;
const ABIToken = contractToken.abi;


const Home = () => {

	const { open } = useWeb3Modal()
	const { chain } = useNetwork()
	const { switchNetwork } = useSwitchNetwork()

	const { address: walletAddress } = useAccount({
		async onConnect() {
			handleConnect()
		}
	})

	const publicClient = createPublicClient({
		chain: pulsechainV4,
		transport: http()
	})

	const [_totalSupply, settotalSupply] = useState(0)
	const [statusError, setStatusError] = useState("")
	const [statusErrorCreate, setStatusErrorCreate] = useState("")
	const [showNotRegistered, setShowNotRegistered] = useState("")
	const [statusLoading, setStatusLoading] = useState("")
	const [success, setSuccess] = useState("")
	const [successR, setSuccessR] = useState("")
	const [_alreadyRegsiter, setAlreadyRegsiter] = useState("")
	const [nftMintingAmount, setnftMintingAmount] = useState(1)
	const [_publicMintMsg, set_publicMintMsg] = useState("Mint Here")
	const [_cost, set_publicSaleCost] = useState("")
	const [_wlcost, set_wlcost] = useState("")
	const [_max_per_wallet, set_max_per_wallet] = useState(10)
	const [_owner, set_owner] = useState("")
	const [myNFTWallet, setmyNFTWallet] = useState(0)
	const [_whitelist_mint_status, set_whitelist_mint_status] = useState("")
	const [_public_mint_status, set_public_mint_status] = useState("")
	const [_whitelistLimitPerWallet, set_whitelistLimitPerWallet] = useState("")
	const [_whitelistCount, set_whitelistCount] = useState("")
	const [_whitelistLimit, set_whitelistLimit] = useState("")
	const [_MAX_SUPPLY, set_MAX_SUPPLY] = useState("")
	const [_navbarOpen, set_navbarOpen] = useState(0)
	const [_register, set_register] = useState(0)
	const [_create, set_create] = useState(0)
	const [_connected, setConnected] = useState(false)
	const [_freeMinLimit, set_OverallFreeMintLimit] = useState(600);
	const [_stateNow, set_stateNow] = useState(Date.now());

	const options = countryList().getData();
	const [txnHash, setTxnHash] = useState("");
	const [_ErrorMsg1, setErrorMsg1] = useState("");
	const [showErrorDiv, setShowErrorDiv] = useState(false);
	const [_name, setName] = useState("");
	const [_Country, setCountry] = useState('');
	const [_CountryLabel, setCountryLabel] = useState('');
	const [_RaffleName, setRaffleName] = useState('');
	const [_ExpectedValue, set_ExpectedValue] = useState('');
	const [_Tagline, setTagline] = useState('');
	const [_EndTime, setEndTime] = useState('');
	const [_TicketPrice, setTicketPrice] = useState('');
	const [ipfsHash, setIpfsHash] = useState("");
	const [previewImage, setPreviewImage] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [errorMsg, setErrorMsg] = useState(""); // To show error if image isn't 1:1
	const [imageUrl, setImageUrl] = useState(null);
	const isFormValid = _RaffleName && previewImage && _Tagline && _EndTime && _TicketPrice;
	const [isRegistered, setIsRegistered] = useState(false);

	const [showDropdown, setShowDropdown] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const toggleDropdown = (e) => {
		e.preventDefault();
		setShowDropdown(!showDropdown);
	}

	const { disconnect } = useDisconnect();

	/*const changeHandler = (selectedOption) => {
		console.log("selectedOption : " + selectedOption);
		setCountry(selectedOption.label); // Store only the label
	};*/

	/*const handleFileChange = async (event) => {
		const file = event.target.files[0];
	
		if (file) {
			const img = new Image();
			img.src = URL.createObjectURL(file);
	
			img.onload = async function () {
				if (img.width !== img.height) {
					setErrorMsg("Only 1:1 ratio images are allowed.");
					setPreviewImage(null);
					setImageUrl(null);
					setIpfsHash(""); // Reset IPFS hash
					return;
				}
	
				setErrorMsg("");
				setPreviewImage(img.src); // Show preview
	
				// Upload to IPFS
				const formData = new FormData();
				formData.append("file", file);
	
				try {
					const response = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
						method: "POST",
						headers: {
							pinata_api_key: "5bf2f2aa6f88beb93342", // Replace with your actual API Key
							pinata_secret_api_key: "78742b68d6281df28fe0301b4bfc68e08720cd9f8c56059564f4c89c218ac6d6" // Replace with your Secret API Key
						},
						body: formData,
					});
	
					const result = await response.json();
					
					if (result.IpfsHash) {
						const ipfsUrl = `https://gateway.pinata.cloud/ipfs/${result.IpfsHash}`;
						
						setIpfsHash(result.IpfsHash); // Store the IPFS hash
						setImageUrl(ipfsUrl); // Store full IPFS URL
					} else {
						throw new Error("IPFS Hash not found in response");
					}
	
				} catch (error) {
					console.error("IPFS upload failed:", error);
					setErrorMsg("Failed to upload image.");
					setIpfsHash(""); // Reset IPFS hash on failure
				}
			};
		}
	};*/

	const handleFileChange = async (event) => {
		const file = event.target.files[0];

		if (file) {
			const img = new Image();
			img.src = URL.createObjectURL(file);

			img.onload = async function () {
				// Create a canvas element
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");

				// Determine the square crop size (smallest side)
				const size = Math.min(img.width, img.height);

				// Set canvas size to 1:1
				canvas.width = size;
				canvas.height = size;

				// Calculate crop position
				const startX = (img.width - size) / 2;
				const startY = (img.height - size) / 2;

				// Draw the cropped image on canvas
				ctx.drawImage(img, startX, startY, size, size, 0, 0, size, size);

				// Convert canvas to blob
				canvas.toBlob(async (blob) => {
					// Convert blob to File for upload
					const croppedFile = new File([blob], file.name, { type: "image/png" });

					// Show preview of cropped image
					const previewURL = URL.createObjectURL(croppedFile);
					setPreviewImage(previewURL); // Show preview

					// Upload cropped image to IPFS
					const formData = new FormData();
					formData.append("file", croppedFile);

					try {
						const response = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
							method: "POST",
							headers: {
								pinata_api_key: "5bf2f2aa6f88beb93342", // Replace with your actual API Key
								pinata_secret_api_key: "78742b68d6281df28fe0301b4bfc68e08720cd9f8c56059564f4c89c218ac6d6" // Replace with your Secret API Key
							},
							body: formData,
						});

						const result = await response.json();

						if (result.IpfsHash) {
							const ipfsUrl = `https://gateway.pinata.cloud/ipfs/${result.IpfsHash}`;

							setIpfsHash(result.IpfsHash); // Store IPFS hash
							setImageUrl(ipfsUrl); // Store IPFS URL
						} else {
							throw new Error("IPFS Hash not found in response");
						}
					} catch (error) {
						console.error("IPFS upload failed:", error);
						setErrorMsg("Failed to upload image.");
						setIpfsHash(""); // Reset IPFS hash on failure
					}
				}, "image/png"); // Convert canvas to PNG format
			};
		}
	};

	const changeHandler = (country) => {
		console.log("selectedOption : " + country.label);

		setCountry(country);
		setCountryLabel(country.label)
	};

	async function openR() {
		set_register(1);
		set_create(0);
	}

	async function closeR() {
		set_register(0);
		set_create(0);
	}

	async function openCreate() {
		set_create(1);
		set_register(0);
		setSuccessR(null);
	}

	async function closNotifications() {
		setShowErrorDiv(false);
		setStatusError(false);
		setShowNotRegistered(false);
		setStatusErrorCreate(false);
		setAlreadyRegsiter(null);
	}

	async function closeNotificationsSuccess() {
		setSuccess(false);
		window.location.reload(true);
	}

	async function closeNav() {
		set_navbarOpen(0);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	//........................................//
	const contract = {
		address: address,
		abi: ABI
	}

	const contracToken = {
		address: addressToken,
		abi: ABIToken
	}

	async function handleConnect() {
		if (chain.id !== 943) {
			switchNetwork(943)
		}

		setConnected(true);
	}

	/*const { refetch: getTotalSupply } = useContractRead({
		...contract,
		functionName: 'totalSupply',
	})

	const { refetch: getBalance } = useContractRead({
		...contract,
		functionName: 'balanceOf',
		args: [walletAddress ? walletAddress : '0x']
	})*/

	const { refetch: isUserRegisteredRefetch } = useContractRead({
		...contract,
		functionName: 'isUserRegistered',
		args: [walletAddress],
		enabled: !!walletAddress,
	});


	useEffect(() => {
		async function checkRegistration() {
			try {
				const { data } = await isUserRegisteredRefetch();
				setIsRegistered(data);
			} catch (err) {
				console.error("Error checking registration:", err);
			}
		}

		checkRegistration();
	}, [walletAddress]);

	const { writeAsync } = useContractWrite({
		...contract,
		//	functionName: 'mint',
		onError(error) {
			if (error.message.includes('balance')) {
				setStatusError(true)
				setStatusLoading(false)
			}
		}
	})

	async function disconnectWallet() {
		setConnected(false);
		disconnect();
		//window.location.reload(true);
	}

	function shortenAddress(walletAddress) {
		try {
			return _connected
				? walletAddress.slice(0, 3) + "..." + walletAddress.slice(-4)
				: "Connect";
		} catch (error) {
			console.log(error);
		}
	}

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderRadius: '5px',
			borderColor: '#ccc',
			padding: '5px',
			margin: '10px 0',
			textAlign: 'left',
			boxShadow: state.isFocused ? `0 0 0 2px rgb(255, 195, 29)` : 'none', // Outline color on focus
			border: state.isFocused ? '1px solid rgb(255, 195, 29)' : '1px solid #ccc', // Border color change on focus
		}),
		placeholder: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		singleValue: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		menu: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		option: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
	};

	async function register() {
		try {
			setStatusLoading(true);

			const res = await writeAsync({
				...contract,
				functionName: "registerUser",
				args: [_name, _CountryLabel],
				gas: 2100000,
				gasPrice: 160000000000
			});

			const txnHash = res.hash;
			setTxnHash(txnHash);
			console.log("Transaction hash:", txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			// Wait for transaction receipt
			const result = await publicClient.waitForTransactionReceipt(res);

			console.log("Transaction result:", result);

			if (result.status === "success") {
				setStatusError(false);
				setSuccessR(true);
				set_register(0);
				setStatusLoading(false);

			} else if (result.status) {
				setSuccessR(false);
				setStatusError(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true); // Show the error div for insufficient funds
				setStatusLoading(false);
				setSuccessR(false);
				setStatusError(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccessR(false);
				setStatusError(false);
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccessR(false);
				setStatusError(false);
				setAlreadyRegsiter(true);
			}
			else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccessR(false);
				setStatusError(false);

				setStatusError(true);
				setStatusLoading(false);
			}

		}
	}

	async function createRaffle() {
		try {
			setStatusLoading(true);

			const ticketPriceInWei = parseEther(_TicketPrice.toString()); // e.g., "0.5"

			const res = await writeAsync({
				...contract,
				functionName: "createRaffle",
				args: [_RaffleName, _Tagline, _EndTime, ticketPriceInWei, imageUrl, _ExpectedValue],
				gas: 2100000,
				gasPrice: 160000000000
			});


			const txnHash = res.hash;
			setTxnHash(txnHash);
			console.log("Transaction hash:", txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			// Wait for transaction receipt
			const result = await publicClient.waitForTransactionReceipt(res);

			console.log("Transaction result:", result);

			if (result.status === "success") {
				setStatusErrorCreate(false);
				setSuccess(true);
				set_create(0);
				setStatusLoading(false);

			} else if (result.status) {
				setSuccess(false);
				setStatusErrorCreate(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true); // Show the error div for insufficient funds
				setStatusLoading(false);
				setSuccess(false);
				setStatusErrorCreate(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusErrorCreate(false);
			}
			else if (e.message.includes("User not registered")) {
				setErrorMsg1("User not registered");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusErrorCreate(false);
				setShowNotRegistered(true);

			} else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);

				setStatusErrorCreate(true);
				setStatusLoading(false);
			}

		}
	}


	return (
		<div class="allWrap">
			<div class="light">
				<div class="cont">
					{_navbarOpen < 1 ?
						(<div class="miniBarMain">
							<div className='loginDiv'><img className='logoPic' onClick={() => window.location.href = 'raffles'} src={logoPic} /></div>
							{_connected ? (
								<button class="login2" onClick={() => disconnectWallet()}>
									{walletAddress === "" ? "Connect Wallet" : shortenAddress(walletAddress)}
								</button>
							) : (
								<button class="login2" onClick={() => { open(); }}>Connect</button>
							)}
							<div className='loginDiv'><img class="navbar" onClick={navbarOpen} src={navbar} /></div>

						</div>) :
						(<div class="miniBarMain">
							<img className='logoPic' onClick={() => window.location.href = 'raffles'} src={logoPic} />
							{_connected ? (
								<button class="login2" onClick={() => disconnectWallet()}>
									{walletAddress === "" ? "Connect Wallet" : shortenAddress(walletAddress)}
								</button>
							) : (
								<button class="login2" onClick={() => { open(); }}>Connect</button>
							)}
							<div className='loginDiv'><img class="navbar" onClick={closeNav} src={wrong} /></div>


						</div>)}

					<div class="headers">

						<div class="h1">

							<div class="connect">
								<div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'raffles'}>Raffles</Link></div>
								<div className="dropdown-wrapper" ref={dropdownRef}>
									<Link
										className="nav-link with-dropdown"
										onClick={toggleDropdown}
									>
										<span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
										<svg
											className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
											width="12"
											height="8"
											viewBox="0 0 12 8"
											fill="none"
										>
											<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
										</svg>
									</Link>

									{showDropdown && (
										<div className="dropdown-menu">
											<Link
												className="dropdown-item"
												onClick={() => window.location.href = 'my-raffles'}
											>
												Created Raffles
											</Link>
											<Link
												className="dropdown-item"
												onClick={() => window.location.href = 'purchased-raffles'}
											>
												Purchased Raffles
											</Link>
										</div>
									)}
								</div>
								
								<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
							</div>

							<div class="logoDiv"><img onClick={() => window.location.href = 'raffles'} src={logoPic} /></div>

							<div class="right">

								<div class="socialIcon">
									<img src={facebook} />
									<img src={instagram} />
									<img src={twitter} />
									<img src={whatsapp} />
								</div>

								{_connected && !isRegistered && (
									<button className='login' onClick={openR}>
										Register
									</button>
								)}
								{_connected ? (
									<button class="login2" onClick={() => disconnectWallet()}>
										{walletAddress === "" ? "Connect Wallet" : shortenAddress(walletAddress)}
									</button>
								) : (
									<button class="login2" onClick={() => { open(); }}>Connect</button>
								)}
							</div>

						</div>

					</div>

					{_navbarOpen > 0 ?
						(<div class="littleNav">
							<div class="connect">
								<div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'raffles'}>Raffles</Link></div>
 								<div className="dropdown-wrapper" ref={dropdownRef}>
									<Link
										className="nav-link with-dropdown"
										onClick={toggleDropdown}
									>
										<span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
										<svg
											className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
											width="12"
											height="8"
											viewBox="0 0 12 8"
											fill="none"
										>
											<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
										</svg>
									</Link>

									{showDropdown && (
										<div className="dropdown-menu">
											<Link
												className="dropdown-item"
												onClick={() => window.location.href = 'my-raffles'}
											>
												Created Raffles
											</Link>
											<Link
												className="dropdown-item"
												onClick={() => window.location.href = 'purchased-raffles'}
											>
												Purchased Raffles
											</Link>
										</div>
									)}
								</div>
								<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
							</div>
							<button className='login' onClick={openR}>Register</button>
							<div class="socialIcon">
								<img src={facebook} />
								<img src={instagram} />
								<img src={twitter} />
								<img src={whatsapp} />
							</div>

						</div>) : null}

					<div class="introductionMain">
						<div class="introduction">
							<div className='title'>TU CENTRAL DE RIFAS</div>
							<div className='subTitle'>La plataforma para albergar rifas para una amplia variedad de artículos.</div>
							<button class="button-7" role="button" onClick={openCreate}>Create Raffle <span className='bold'>>></span></button>
						</div>

						<img class="banner" src={banner} />

					</div>
					<img className='line' src={line} />
				</div>

				{_register > 0 ?
					<div className="popup-overlay">
						<div className="popup-container">
							<div className='closeR' onClick={closeR}>✖</div>

							<div className='regsiterH'>Register</div>
							{_connected ?
								<div className='regsiterH2' onClick={() => disconnectWallet()}>{shortenAddress(walletAddress)}</div>
								: null}

							<div className='inputMain'>

								<div className='name'>Name</div>

								<input id="inputR" placeholder='Jane Doe'
									onChange={(e) => {
										setName(e.target.value);
									}}
									value={_name}
								></input>

							</div>

							<Select
								options={options}
								name="_Country" value={_Country}
								onChange={changeHandler}
								placeholder="Select your country"
								styles={customStyles} // Apply custom styles		
								id="selectSection"

							/>

							{_connected ?
								<button className='submit' onClick={register}>SUBMIT</button> :
								<button className='submit' onClick={() => { open(); }}>Connect</button>}

							<div className='registerDiv2' onClick={openCreate}>Create Raffle</div>

						</div>
					</div> : null}

				{_create > 0 ?
					<div className="popup-overlay">
						<div className="popup-container2">

							<div class="raffle-form" id="raffleForm">
								<div className='closeR' onClick={closeR}>✖</div>

								<div class="form-group">
									<label for="name">Raffle Name</label>
									<input required maxLength="25" type="text" id="name" name="name" onChange={(e) => { setRaffleName(e.target.value); }}
										value={_RaffleName} required placeholder="Enter the name of the raffle" />
								</div>

								<div className="form-group">
									<label htmlFor="raffleImage">Upload Raffle Image</label>

									{previewImage && (
										<div className="image-preview">
											<img src={previewImage} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
										</div>
									)}

									<input
										type="file"
										id="raffleImage"
										name="raffleImage"
										accept="image/*"
										onChange={handleFileChange}
										required
									/>
								</div>

								<div class="form-group">
									<label for="tagline">Tagline</label>
									<input required maxLength="35" type="text" id="tagline" name="tagline" required placeholder="Enter a catchy tagline"
										onChange={(e) => { setTagline(e.target.value); }} value={_Tagline}
									/>
								</div>

								<div className="form-group">
									<label htmlFor="endTime">End Time</label>
									<input
										type="datetime-local"
										id="endTime"
										name="endTime"
										required
										onChange={(e) => {
											// Get selected date string from input
											const dateStr = e.target.value;
											// Create a date object in local time
											const localDate = new Date(dateStr);
											// Convert to Unix timestamp (seconds)
											const timestamp = Math.floor(localDate.getTime() / 1000);
											setEndTime(timestamp);
										}}
										value={_EndTime ? (() => {
											// Create a date object from the Unix timestamp
											const date = new Date(_EndTime * 1000);
											// Format to YYYY-MM-DDThh:mm
											const year = date.getFullYear();
											const month = String(date.getMonth() + 1).padStart(2, '0');
											const day = String(date.getDate()).padStart(2, '0');
											const hours = String(date.getHours()).padStart(2, '0');
											const minutes = String(date.getMinutes()).padStart(2, '0');
											return `${year}-${month}-${day}T${hours}:${minutes}`;
										})() : ''}
										min={(() => {
											// Get current date and time
											const now = new Date();
											// Add 5 minutes to current time to avoid immediate expiration
											now.setMinutes(now.getMinutes() + 5);
											// Format to YYYY-MM-DDThh:mm
											const year = now.getFullYear();
											const month = String(now.getMonth() + 1).padStart(2, '0');
											const day = String(now.getDate()).padStart(2, '0');
											const hours = String(now.getHours()).padStart(2, '0');
											const minutes = String(now.getMinutes()).padStart(2, '0');
											return `${year}-${month}-${day}T${hours}:${minutes}`;
										})()}
										step="60" // Set step to 60 seconds for better time control
									/>
									<small className="form-text text-muted">
										Please select a date and time at least 5 minutes from now.
									</small>
								</div>

								<div className="form-group">
									<label htmlFor="ticketPrice">
										Ticket Price (POL) <img src={coin} />
									</label>
									<input
										required
										type="number"
										id="ticketPrice"
										name="ticketPrice"
										step="any"
										placeholder="Enter the ticket price"
										onChange={(e) => {
											// Ensure only valid number values are set
											const value = e.target.value;
											if (/^\d*\.?\d*$/.test(value)) {
												setTicketPrice(value);
											}
										}}
										value={_TicketPrice}
										onKeyPress={(e) => {
											// Prevent any non-numeric characters, including "-"
											if (e.key === '-' || !/[0-9.]/.test(e.key)) {
												e.preventDefault();
											}
										}}
									/>
								</div>


								<div className="form-group">
									<label htmlFor="ticketPrice">
										Maximum Ticket Amount
									</label>
									<input
										required
										type="number"
										id="ticketPrice"
										name="ticketPrice"
										step="any"
										placeholder="Enter the maximum ticket amount"
										onChange={(e) => {
											// Ensure only valid number values are set
											const value = e.target.value;
											if (/^\d*\.?\d*$/.test(value)) {
												set_ExpectedValue(value);
											}
										}}
										value={_ExpectedValue}
										onKeyPress={(e) => {
											// Prevent any non-numeric characters, including "-"
											if (e.key === '-' || !/[0-9.]/.test(e.key)) {
												e.preventDefault();
											}
										}}
									/>
								</div>

								<button
									className="submit-btn"
									onClick={createRaffle}
									disabled={!isFormValid}
									style={!isFormValid ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
								>
									Create Raffle
								</button>

								<div className='registerDiv' onClick={openR}>Register</div>

							</div>
						</div>
					</div> : null}

				{successR ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closeNotificationsSuccess}>✖</div>
							<img className='correct' src={correct} />
							<div className='notificationHMsg'>Registered Successfully</div>
						</div>
						<div className='raffleCreate' onClick={openCreate}>Now you can create raffles <img src={back} /></div>

					</div> : null}

				{success ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closeNotificationsSuccess}>✖</div>
							<img className='correct' src={correct} />
							<div className='notificationHMsg'>Raffle Created Successfully</div>
						</div>
						<div className='raffleCreate' onClick={() => window.location.href = 'raffles'}>See all raffles <img src={back} /></div>

					</div> : null}

				{statusError ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>Sorry Something went wrong</div>
							<div className='notificationH2' id="error">Please try again</div>
						</div>
					</div> : null}

				{statusErrorCreate ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>Sorry Something went wrong</div>
							<div className='notificationH2' id="error">Please try again</div>
						</div>
					</div> : null}

				{statusLoading ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div class="loader"></div>
							<div className='notificationHMsg'>Loading</div>
						</div>
					</div> : null}

				{showErrorDiv ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>Insufficent Funds</div>
							<div className='notificationH2' id="error2">Please fill your wallet</div>
						</div>
					</div> : null}

				{showNotRegistered ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>User Not Registered</div>
							<div className='notificationH2' id="error2">Please register with your wallet</div>
						</div>
					</div> : null}

				{_alreadyRegsiter ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>The User is Already Registered</div>
							<div className='notificationH2' id="error2">Please use a different wallet</div>
						</div>
					</div> : null}

				<Element name="about">
					<Intro />
				</Element>

				<img className='line2' src={line2} />

				<Element name="raffles">
					<Story />
				</Element>

				<img className='line2' src={line2_3} />

				<Element name="process">
					<Steps />
				</Element>

				<img className='line2' src={line3} />

				<Footer />

			</div >
		</div >
	)

}
export default Home;
